import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAdminCheck } from '../../hooks/useAdminCheck';

const PrivateAdminRoute = ({ children }) => {
  const { isAdmin, loading, error } = useAdminCheck();

  // Show loading while checking admin status
  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="200px"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Verifying access...
        </Typography>
      </Box>
    );
  }

  // Show error if there was an issue checking admin status
  if (error) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="200px"
      >
        <Typography variant="body1" color="error">
          Error verifying access. Please try again.
        </Typography>
      </Box>
    );
  }

  // If user is admin, render the children (protected component)
  // Otherwise, redirect to home page
  return isAdmin ? children : <Navigate to="/" replace />;
};

export default PrivateAdminRoute;